import clsx from 'clsx';

interface UnderlinesProps {
  length?: number;
  wordSoundsLength: number;
  letterWidthClass: string;
  positionOverrideClass?: string;
  /** If provided, overrides top position using absolute pixels */
  positionTopPx?: number;
  /** If provided, overrides top position using percentage of parent height (0-100) */
  positionTopPercent?: number;
}

export const Underlines = ({
  length = 0,
  wordSoundsLength,
  letterWidthClass,
  positionOverrideClass,
  positionTopPx,
  positionTopPercent,
}: UnderlinesProps) =>
  length > 0 && (
    <div
      className={clsx(
        'absolute left-0 right-0 w-full flex gap-3 justify-start px-3',
        'transition-all duration-300 ease-in-out',
        !positionOverrideClass &&
          positionTopPx === undefined &&
          positionTopPercent === undefined &&
          (length >= wordSoundsLength ? 'top-64' : 'top-48'),
        positionOverrideClass,
      )}
      style={
        positionTopPx !== undefined
          ? { top: `${positionTopPx}px` }
          : positionTopPercent !== undefined
            ? { top: `${positionTopPercent}%` }
            : undefined
      }
    >
      {Array.from({ length }).map((_, i) => (
        <div
          key={i}
          className={clsx('h-2 bg-gray-300 rounded-full', letterWidthClass)}
        ></div>
      ))}
    </div>
  );
